export default __webpack_public_path__ + "static/media/my-training.131450cf.svg";